(function (angular) {
	'use strict';

	var documentLinkObject = {
		templateUrl: [
			'STATIC_BASE_PATH',
			templateUrlFunction
		],
		controller: [
			DocumentLinkFunction
		],
		bindings: {
			linkUrl: '<',
			thumbnailUrl: '<',
			title: '<',
			extension: '<?',
			sizeInBytes: '<?'
		},
		controllerAs: 'documentLink'
	};

	angular
		.module('productPage')
		.component('documentLink', documentLinkObject);

	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/reits/product-pages/document-link.html';
	}

	function DocumentLinkFunction() {
		var documentLink = this;

		documentLink.$onInit = function() {
			documentLink.isAttachment = angular.isDefined(documentLink.extension) && angular.isDefined(documentLink.sizeInBytes);
		};
	}
})(window.angular);
